import React, { useContext, useEffect, useState } from "react";
import { Button, Stack, TextField, Tooltip, Typography } from "@mui/material";
import { QuestionsContext } from "../../../../../../../provider/MyContexts";
import { AutoAwesome } from "@mui/icons-material";
import MenuBookIcon from "@mui/icons-material/MenuBook";

type Props = {};
export default function QuestionTextsArea(props: Props) {
  const {} = props;

  const { selectedQuestion, generateQuestion, isLoading, updateQuestionValue } =
    useContext(QuestionsContext);

  const [text, setText] = useState<string>("");

  const handleTextChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setText(e.target.value);
  };

  useEffect(() => {
    setText(selectedQuestion.questionText);
  }, [selectedQuestion]);

  return (
    <Stack
      width={"100%"}
      marginTop={1}
      marginBottom={2}
      sx={{
        position: "relative",
      }}
      spacing={1}
    >
      {selectedQuestion.citation && selectedQuestion.citation.length && (
        <Stack
          sx={{
            position: "absolute",
            top: "rem",
            right: "1rem",
          }}
        >
          <Tooltip
            placement="left"
            title={
              <Stack>
                <Typography fontWeight={600} variant="body_S" marginBottom={2}>
                  AIが参照したURL
                </Typography>
                {selectedQuestion.citation.map((cite, index) => (
                  <Typography key={index} variant="body_S" gutterBottom>
                    {cite}
                  </Typography>
                ))}
              </Stack>
            }
            componentsProps={{
              popper: {
                sx: {
                  userSelect: "text",
                },
              },
            }}
          >
            <MenuBookIcon />
          </Tooltip>
        </Stack>
      )}
      <Typography variant="heading_XS" marginBottom={1}>
        設問文
      </Typography>
      {selectedQuestion.questionSupplementPrev.length ? (
        <TextField
          size="small"
          disabled
          label={"補足文（設問前）"}
          value={selectedQuestion.questionSupplementPrev[0].text}
        />
      ) : (
        <></>
      )}

      <Stack
        width={"100%"}
        direction={"row"}
        spacing={1}
        alignItems={"center"}
        justifyContent={"flex-start"}
        marginBottom={1}
      >
        <Button
          variant="outlined"
          size="small"
          onClick={() => generateQuestion("TEXT")}
          disabled={!selectedQuestion.questionType || !selectedQuestion.questionTitle}
          loading={isLoading}
          loadingPosition="start"
        >
          <Stack direction="row" spacing={1} alignItems="center">
            <AutoAwesome fontSize="small" />
            <Typography variant="button">設問文を生成する</Typography>
          </Stack>
        </Button>
        {/* <Button variant="outlined" onClick={() => handleAiMenuClick()} size="small">
          <Typography variant="body_S">詳細</Typography>
        </Button> */}
      </Stack>
      <Stack direction={"row"} spacing={1} justifyContent={"center"} marginBottom={1}>
        <TextField
          value={text}
          disabled={isLoading}
          onChange={handleTextChange}
          onBlur={() => updateQuestionValue("questionText", text)}
          sx={{ flex: 1 }}
          size="small"
          multiline
          minRows={1}
          maxRows={5}
          label="設問文"
        />
      </Stack>
      {selectedQuestion.questionSupplement.length ? (
        <TextField
          size="small"
          disabled
          label={"補足文（設問後）"}
          value={selectedQuestion.questionSupplement[0].text}
        />
      ) : (
        <></>
      )}
    </Stack>
  );
}
